import { CONFERENCE_FAILED, CONFERENCE_JOINED, CONFERENCE_LEFT } from '../base/conference/actionTypes';
import { CONNECTION_ESTABLISHED, CONNECTION_FAILED } from '../base/connection/actionTypes';
import { hideDialog } from '../base/dialog/actions';
import { isDialogOpen } from '../base/dialog/functions';
import { JitsiConferenceErrors, JitsiConnectionErrors } from '../base/lib-jitsi-meet';
import { MEDIA_TYPE } from '../base/media/constants';
import MiddlewareRegistry from '../base/redux/MiddlewareRegistry';
import { isLocalTrackMuted } from '../base/tracks/functions.any';
import { parseURIString } from '../base/util/uri';
import { openLogoutDialog } from '../settings/actions';
import { CANCEL_LOGIN, LOGIN, LOGOUT, STOP_WAIT_FOR_OWNER, UPGRADE_ROLE_FINISHED, WAIT_FOR_OWNER } from './actionTypes';
import { disableModeratorLogin, hideLoginDialog, openLoginDialog, openTokenAuthUrl, openWaitForOwnerDialog, redirectToDefaultLocation, stopWaitForOwner, waitForOwner } from './actions';
import { LoginDialog, WaitForOwnerDialog } from './components';
import { getTokenAuthUrl, isTokenAuthEnabled } from './functions';
import logger from './logger';
import { getWSUrl } from '../welcome/functions';
/**
 * Middleware that captures connection or conference failed errors and controls
 * moderator login availability and {@link LoginDialog}.
 *
 * FIXME Some of the complexity was introduced by the lack of dialog stacking.
 *
 * @param {Store} store - Redux store.
 * @returns {Function}
 */
MiddlewareRegistry.register(store => next => async (action) => {
    switch (action.type) {
        case CANCEL_LOGIN: {
            const { dispatch, getState } = store;
            const state = getState();
            const { thenableWithCancel } = state['features/authentication'];
            thenableWithCancel?.cancel();
            // The LoginDialog can be opened on top of "wait for owner". The app
            // should navigate only if LoginDialog was open without the
            // WaitForOwnerDialog.
            if (!isDialogOpen(store, WaitForOwnerDialog)) {
                if (_isWaitingForOwner(store)) {
                    // Instead of hiding show the new one.
                    const result = next(action);
                    dispatch(openWaitForOwnerDialog());
                    return result;
                }
                dispatch(hideLoginDialog());
                const { authRequired, conference } = state['features/base/conference'];
                const { passwordRequired } = state['features/base/connection'];
                // Only end the meeting if we are not already inside and trying to upgrade.
                // NOTE: Despite it's confusing name, `passwordRequired` implies an XMPP
                // connection auth error.
                if ((passwordRequired || authRequired) && !conference) {
                    dispatch(redirectToDefaultLocation());
                }
            }
            break;
        }
        case CONFERENCE_FAILED: {
            const { error } = action;
            const { getState } = store;
            const state = getState();
            const room = state['features/base/conference'].room;
            //@ts-ignore
            //console.log("MS -----> Middleware Authentication error.name: ", action.error.name);
            // XXX The feature authentication affords recovery from
            // CONFERENCE_FAILED caused by
            // JitsiConferenceErrors.AUTHENTICATION_REQUIRED.
            let recoverable = false;
            // eslint-disable-next-line @typescript-eslint/no-unused-vars
            const [_lobbyJid, lobbyWaitingForHost] = error.params;
            //riportato qui la verifyMeetRoom e la verifyProsodyToken nel caso di moderatore, per avallare la dispatch waitForOwner
            if (room && error.name === JitsiConferenceErrors.AUTHENTICATION_REQUIRED) {
                let _verifyMeetRoom = "https://" + getWSUrl() + "/verifyMeetRoom/" + room + "/0/";
                //@ts-ignore
                //console.log("MS -----> verifyMeetRoom da middleware CONFERENCE_FAILED : ", _verifyMeetRoom);
                const request = async () => {
                    const response = await fetch(_verifyMeetRoom);
                    const json = await response.json();
                    //console.log("MS -----> result: ", json.result);
                    if (json.result == 1) {
                        //@ts-ignore
                        let us = localStorage.getItem("user");
                        if (us != null) {
                            var user = JSON.parse(us?.toString());
                            if (user !== null && user.result == 1) {
                                if (room === user.roomname) {
                                    //console.log("MS -----> prima di verifyProsodyToken");
                                    const requestToken = async () => {
                                        const responseToken = await fetch('https://' + getWSUrl() + '/verifyProsodyToken/' + user.username + '/' + user.token + '/');
                                        const jsonToken = await responseToken.json();
                                        if (jsonToken.result == 1) {
                                            //console.log("MS -----> Room exists, logged, admin, token valid");
                                            recoverable = setRecoverable(error, recoverable);
                                            store.dispatch(openLoginDialog());
                                        }
                                        else {
                                            //console.log("MS -----> Room exists, logged, admin, token invalid");
                                            window.location.href = window.location.origin + "#logout";
                                        }
                                    };
                                    requestToken();
                                }
                                else {
                                    // Room exists, logged, not admin
                                    recoverable = setRecoverable(error, recoverable);
                                }
                            }
                            else {
                                // Room exists, not logged
                                recoverable = setRecoverable(error, recoverable);
                            }
                        }
                        else {
                            recoverable = setRecoverable(error, recoverable);
                        }
                    }
                    else {
                        window.location.href = window.location.origin + "#error"; // Room doesn't exists
                    }
                };
                await request();
            }
            if (error.name === JitsiConferenceErrors.MEMBERS_ONLY_ERROR && lobbyWaitingForHost) {
                //console.log("MS -----> MEMBERS_ONLY_ERROR ");
                recoverable = setRecoverable(error, recoverable);
            }
            if (recoverable) {
                store.dispatch(waitForOwner());
            }
            else {
                store.dispatch(stopWaitForOwner());
            }
            /*
             recoverable = error.recoverable;
            }
            // codice Jitsi originale, lasciato per riferimento, controllare stabile 11031
            if (error.name === JitsiConferenceErrors.MEMBERS_ONLY_ERROR && lobbyWaitingForHost) {
                if (recoverable) {
                    store.dispatch(enableModeratorLogin());
                } else {
                    store.dispatch(disableModeratorLogin());
                }
            } else if (error.name === JitsiConferenceErrors.AUTHENTICATION_REQUIRED) {
                }
            }
            */
            break;
        }
        case CONFERENCE_JOINED: {
            const { dispatch } = store;
            if (_isWaitingForModerator(store)) {
                dispatch(disableModeratorLogin());
            }
            if (_isWaitingForOwner(store)) {
                dispatch(stopWaitForOwner());
            }
            dispatch(hideLoginDialog());
            break;
        }
        case CONFERENCE_LEFT:
            store.dispatch(disableModeratorLogin());
            store.dispatch(stopWaitForOwner());
            break;
        case CONNECTION_ESTABLISHED:
            store.dispatch(hideLoginDialog());
            break;
        case CONNECTION_FAILED: {
            const { error } = action;
            const { getState } = store;
            const state = getState();
            const { jwt } = state['features/base/jwt'];
            if (error
                && error.name === JitsiConnectionErrors.PASSWORD_REQUIRED
                && typeof error.recoverable === 'undefined'
                && !jwt) {
                error.recoverable = true;
                _handleLogin(store);
            }
            break;
        }
        case LOGIN: {
            _handleLogin(store);
            break;
        }
        case LOGOUT: {
            _handleLogout(store);
            break;
        }
        case STOP_WAIT_FOR_OWNER:
            _clearExistingWaitForOwnerTimeout(store);
            store.dispatch(hideDialog('WaitForOwnerDialog', WaitForOwnerDialog));
            break;
        case UPGRADE_ROLE_FINISHED: {
            const { error, progress } = action;
            if (!error && progress === 1) {
                store.dispatch(hideLoginDialog());
            }
            break;
        }
        case WAIT_FOR_OWNER: {
            _clearExistingWaitForOwnerTimeout(store);
            const { handler, timeoutMs } = action;
            action.waitForOwnerTimeoutID = setTimeout(handler, timeoutMs);
            // The WAIT_FOR_OWNER action is cyclic, and we don't want to hide the
            // login dialog every few seconds.
            isDialogOpen(store, LoginDialog)
                || store.dispatch(openWaitForOwnerDialog());
            break;
        }
    }
    return next(action);
});
/**
* Set Recoverable
*/
function setRecoverable(error, recoverable) {
    if (typeof error.recoverable === 'undefined') {
        error.recoverable = true;
    }
    recoverable = error.recoverable;
    return recoverable;
}
/**
 * Will clear the wait for conference owner timeout handler if any is currently
 * set.
 *
 * @param {Object} store - The redux store.
 * @returns {void}
 */
function _clearExistingWaitForOwnerTimeout({ getState }) {
    const { waitForOwnerTimeoutID } = getState()['features/authentication'];
    waitForOwnerTimeoutID && clearTimeout(waitForOwnerTimeoutID);
}
/**
 * Checks if the cyclic "wait for conference owner" task is currently scheduled.
 *
 * @param {Object} store - The redux store.
 * @returns {boolean}
 */
function _isWaitingForOwner({ getState }) {
    return Boolean(getState()['features/authentication'].waitForOwnerTimeoutID);
}
/**
 * Checks if the cyclic "wait for moderator" task is currently scheduled.
 *
 * @param {Object} store - The redux store.
 * @returns {boolean}
 */
function _isWaitingForModerator({ getState }) {
    return getState()['features/authentication'].showModeratorLogin;
}
/**
 * Handles login challenge. Opens login dialog or redirects to token auth URL.
 *
 * @param {Store} store - The redux store in which the specified {@code action}
 * is being dispatched.
 * @returns {void}
 */
function _handleLogin({ dispatch, getState }) {
    const state = getState();
    const config = state['features/base/config'];
    const room = state['features/base/conference'].room;
    const { locationURL = { href: '' } } = state['features/base/connection'];
    const { tenant } = parseURIString(locationURL.href) || {};
    const { enabled: audioOnlyEnabled } = state['features/base/audio-only'];
    const audioMuted = isLocalTrackMuted(state['features/base/tracks'], MEDIA_TYPE.AUDIO);
    const videoMuted = isLocalTrackMuted(state['features/base/tracks'], MEDIA_TYPE.VIDEO);
    const refreshToken = state['features/base/jwt'].refreshToken;
    if (!room) {
        logger.warn('Cannot handle login, room is undefined!');
        return;
    }
    if (!isTokenAuthEnabled(state)) {
        dispatch(openLoginDialog());
        return;
    }
    getTokenAuthUrl(config, locationURL, {
        audioMuted,
        audioOnlyEnabled,
        skipPrejoin: true,
        videoMuted
    }, room, tenant, refreshToken)
        .then((tokenAuthServiceUrl) => {
        if (!tokenAuthServiceUrl) {
            logger.warn('Cannot handle login, token service URL is not set');
            return;
        }
        return dispatch(openTokenAuthUrl(tokenAuthServiceUrl));
    });
}
/**
 * Handles logout challenge. Opens logout dialog and hangs up the conference.
 *
 * @param {Store} store - The redux store in which the specified {@code action}
 * is being dispatched.
 * @param {string} logoutUrl - The url for logging out.
 * @returns {void}
 */
function _handleLogout({ dispatch, getState }) {
    const state = getState();
    const { conference } = state['features/base/conference'];
    if (!conference) {
        return;
    }
    dispatch(openLogoutDialog());
}
